import {Provider} from '@angular/core';
import {
    ApActivityListComponent
} from "../component/protected-components/ap-activity-list-component/ap-activity-list.component";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";

import {
    ApAgentActivityPlannerComponent
} from '../component/protected-components/ap-agent-activity-planner/ap-agent-activity-planner.component';
import {
    ApConsultantInfoComponent
} from '../component/protected-components/ap-consultant-info-component/ap-consultant-info.component';
import {
    ApPlanningDetailComponent
} from '../component/protected-components/ap-planning-detail/ap-planning-detail.component';
import {
    ApAppointmentActivityComponent
} from '../component/protected-components/ap-tool-panel/components/ap-appointment-activity/ap-appointment-activity.component';
import {
    AppointmentCardComponent
} from '../component/protected-components/ap-tool-panel/components/ap-appointment-activity/appointment-card-component/appointment-card.component';
import {ApToolPanelComponent} from '../component/protected-components/ap-tool-panel/ap-tool-panel.component';
import {
    ApActivityFormComponent
} from '../component/protected-components/ap-tool-panel/components/ap-appointment-activity/ap-apponitment-activity-forms/ap-activity-form/ap-activity-form.component';
import {
    ApAppointmentBookingComponent
} from '../component/protected-components/ap-tool-panel/components/ap-appointment-activity/ap-apponitment-activity-forms/ap-appointment-booking/ap-appointment-booking.component';
import {
    ApToolPanelBarComponent
} from '../component/protected-components/ap-tool-panel/components/ap-tool-panel-bar/ap-tool-panel-bar.component';
import {
    ApAppointmentActivityFormsComponent
} from '../component/protected-components/ap-tool-panel/components/ap-appointment-activity/ap-apponitment-activity-forms/ap-appointment-activity-forms.component';
import {ApConfigPage} from "../page/config/ap-config.page";
import {
    ApAgentPlannerDashboardOverviewComponent
} from "../page/ap-agent-planner-dashboard-overview/ap-agent-planner-dashboard-overview.component";


const apModuleEntry: TestModuleDefinition = {
    key: 'ap',
    label: 'Agent Planner (ap)',
    components: [
        {
            key: 'apActivityListComponent',
            component: ApActivityListComponent,
            selector: 'ap-activity-list',
            type: 'component',
            label: 'Activity List'
        },
        {
            key: 'apAgentActivityPlannerComponent',
            component: ApAgentActivityPlannerComponent,
            selector: 'ap-agent-activity-planner',
            type: 'component',
            label: 'Agent Activity Planner'
        },
        {
            key: 'apConsultantInfoComponent',
            component: ApConsultantInfoComponent,
            selector: 'ap-consultant-info',
            type: 'component',
            label: 'Consultant Info'
        },
        {
            key: 'apPlanningDetailComponent',
            component: ApPlanningDetailComponent,
            selector: 'ap-planning-detail',
            type: 'component',
            label: 'Planning Detail'
        },
        {
            key: 'apAppointmentActivityComponent',
            component: ApAppointmentActivityComponent,
            selector: 'ap-appointment-activity',
            type: 'component',
            label: 'Appointment Activity'
        },
        {
            key: 'apActivityFormComponent',
            component: ApActivityFormComponent,
            selector: 'ap-activity-form',
            type: 'component',
            label: 'Activity Form'
        },
        {
            key: 'appointmentCardComponent',
            component: AppointmentCardComponent,
            selector: 'app-appointment-card',
            type: 'component',
            label: 'Appointment Card'
        },
        {
            key: 'apAppointmentBookingComponent',
            component: ApAppointmentBookingComponent,
            selector: 'ap-appointment-booking',
            type: 'component',
            label: 'Appointment Booking'
        },
        {
            key: 'apAppointmentActivityFormsComponent',
            component: ApAppointmentActivityFormsComponent,
            selector: 'ap-appointment-activity-forms',
            type: 'component',
            label: 'Appointment Activity Forms'
        },
        {
            key: 'apToolPanelComponent',
            component: ApToolPanelComponent,
            selector: 'ap-tool-panel',
            type: 'component',
            label: 'Tool Panel'
        },
        {
            key: 'apToolPanelBarComponent',
            component: ApToolPanelBarComponent,
            selector: 'ap-tool-panel-bar',
            type: 'component',
            label: 'Tool Panel Bar'
        },
        {
            key: 'apAppointmentActivityComponent',
            component: ApAppointmentActivityComponent,
            selector: 'ap-appointment-activity',
            type: 'component',
            label: 'Appointment Activity'
        },
        {
            key: 'ApConfigPage',
            component: ApConfigPage,
            selector: 'mvs-ap-config',
            type: 'PageComponent',
            label: 'Appointment Config Page'
        },
        {
            key: 'ApAgentPlannerDashboardOverviewComponent',
            component: ApAgentPlannerDashboardOverviewComponent,
            selector: 'ap-agent-planner-dashboard-overview',
            type: 'PageComponent',
            label: 'Agent Planner Dashboard Page'
        }
    ]
};

export const AP_TEST_PROVIDERS: Provider[] = [
    { provide: TEST_MODULE_REGISTRY, useValue: apModuleEntry, multi: true }
];